import _objectDestructuringEmpty from '@babel/runtime/helpers/objectDestructuringEmpty';
import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import Layout from './Layout.js';
import Formwizard from '../../../wizard/index.js';
import UserDataStep from './UserDataStep.js';
import { jsx } from '@emotion/react';
var Clean = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return jsx(Layout, {
    ref: ref
  }, jsx(Formwizard, _extends({
    components: {
      UserDataStep: UserDataStep
    }
  }, props)));
});
export { Clean as default };